import {useCallback, useState} from 'react'
import {useCookie} from 'react-use'
import {logger} from 'src/common/logger'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

type Status = 'idle' | 'loading' | 'success' | 'error'

type UseHubspotEmailSubmitProps = {
  hubspotPortalId: string
  hubspotFormId: string
  pageUid: string
}

export const useHubspotEmailSubmit = ({hubspotPortalId, hubspotFormId, pageUid}: UseHubspotEmailSubmitProps) => {
  const [status, setStatus] = useState<Status>('idle')
  const [hutk] = useCookie('hubspotutk')

  const submitEmail = useCallback(
    async (email: string) => {
      if (!EMAIL_REGEX.test(email)) {
        setStatus('error')
        return
      }

      setStatus('loading')

      try {
        const response = await fetch(
          `https://api.hsforms.com/submissions/v3/integration/submit/${hubspotPortalId}/${hubspotFormId}`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              fields: [{name: 'email', value: email}],
              context: {
                pageUri: window.location.href,
                pageName: pageUid,
                ...(hutk?.length && {hutk}),
              },
            }),
          },
        )

        if (!response.ok) {
          logger.error('HubSpot form submission failed', {
            context: 'blob-section-email',
            httpStatus: response.status,
            formId: hubspotFormId,
          })

          setStatus('error')
          return
        }

        setStatus('success')
      } catch {
        logger.error('HubSpot form submission failed', {
          context: 'blob-section-email',
          formId: hubspotFormId,
        })

        setStatus('error')
      }
    },
    [hubspotPortalId, hubspotFormId, pageUid, hutk],
  )

  return {status, submitEmail}
}
